import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import selectorOwner from '@/components/selector/owner'

function renderIdField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.id,
        label: this.getTranslate(`${Services.tokens}.labels.id`),
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.id = event
        }
      }
    }
  )
}
function renderOwnerField(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        label: this.getTranslate(`${Services.tokens}.labels.owner`),
        dense: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.tokens}-filter`
    },
    [
      renderIdField.call(this, h),
      renderOwnerField.call(this, h)
    ]
  )
}
